export default __webpack_public_path__ + "static/media/photo.cbbb4a2d.png";